import { render, staticRenderFns } from "./HistoryOrder.vue?vue&type=template&id=0645c56e&scoped=true"
import script from "./HistoryOrder.vue?vue&type=script&lang=js"
export * from "./HistoryOrder.vue?vue&type=script&lang=js"
import style0 from "./HistoryOrder.vue?vue&type=style&index=0&id=0645c56e&prod&lang=css"
import style1 from "./HistoryOrder.vue?vue&type=style&index=1&id=0645c56e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0645c56e",
  null
  
)

export default component.exports